import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = ["invoice--position"]

  static targets = ["withoutArrDue", "arrFeeRateWrapper", "arrFeeRate"]

  connect() {
    if (this.hasWithoutArrDueTarget) {
      this.updateArrFeeRateVisibility()
    }
  }

  invoicePositionOutletConnected(outlet) {
    outlet.toggleArrDueRow(this.withoutArrDueTarget.checked)
  }

  toggleArrDue() {
    this.updateArrFeeRateVisibility()
    if (this.hasInvoicePositionOutlet) {
      this.invoicePositionOutlet.toggleArrDueRow(this.withoutArrDueTarget.checked)
    }
  }

  updateArrFeeRateVisibility() {
    this.arrFeeRateWrapperTarget.classList.toggle("hidden", this.withoutArrDueTarget.checked)
  }

  feeRateChanged() {
    if (this.hasInvoicePositionOutlet) {
      this.invoicePositionOutlet.updateArrFeeRate(this.arrFeeRateTarget.value)
    }
  }
}
